import {useSelector} from 'react-redux';
import {eventInEditMode} from '~/common/fabric/reducers/details/selectors';
import {selectRsvpOptional} from '~/common/fabric/reducers/fabricDesign/selectors';
import {InformationLineIcon} from '~library/svg/InformationLineIcon';
import {aquamarine} from '~libSass/base/_exports.sass';
import {GuestOptionToggle} from './GuestOptionToggle';

interface RsvpToggleProps {
  onChange: (value: boolean) => void;
  rsvpOff: boolean;
}

export const RsvpToggle = ({onChange, rsvpOff}: RsvpToggleProps) => {
  const rsvpOptional = useSelector(selectRsvpOptional);
  const inEditMode = useSelector(eventInEditMode);
  const disabled = rsvpOptional && inEditMode;

  const subtitle = (
    <>
      Let guests respond to your invitation so you can see who's coming.
      <br />
      <span className="request-rsvps-toggle-info">
        <InformationLineIcon ratio={0.5} color={aquamarine} />
        This cannot be adjusted after sending.
      </span>
    </>
  );

  if (!rsvpOptional) {
    return null;
  }

  return (
    <GuestOptionToggle
      checked={!rsvpOff}
      heading="Collect RSVPs"
      description={subtitle}
      onChange={onChange}
      dataQaId="request-rsvps-toggle"
      disabled={disabled}
    />
  );
};
